import {Platform, Text} from 'react-native';
import styled from 'styled-components';

const BlueTextInlineElem =
  Platform.OS === 'android' || Platform.OS === 'ios'
    ? styled(Text)`
        ${{
          color: ({theme}) => theme.colors.text.base,
          fontFamily: 'IRANSans',
          lineHeight: '20px',
          alignSelf: 'center',
        }}
        font-size: 18px;
        font-weight: 600;
      `
    : styled.span`
        ${{
          color: ({theme}) => theme.colors.text.base,
          fontFamily: 'IRANSans',
          lineHeight: '20px',
          alignSelf: 'center',
        }}
        font-size: 14px;
        font-weight: 300;
      `;

export default BlueTextInlineElem;
